import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ImgResponsive from './ImgResponsive';

const ads1 = "/images/SQ_business/SQ_business-1.jpg";
const ads2 = "/images/SQ_business/SQ_business-2.jpg";
const ads3 = "/images/SQ_business/SQ_business-3.jpg";

const CarouselBusiness: React.FC = () => {

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '98%', margin: '0 auto', padding: '10px 2px 2px 2px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={ads1} alt="BYD E6 - Premium Electric MPV" />
        </div>
        <div>
          <ImgResponsive src={ads2} alt="BYD E6 Photos" />
        </div>
        <div>
          <ImgResponsive src={ads3} alt="Electric &amp; Premium - BYD E6" />
        </div>
      </Slider>
    </Box>
  );
};

export default CarouselBusiness;
